import { render, staticRenderFns } from "./shareholder.vue?vue&type=template&id=16f4b573&scoped=true&"
import script from "./shareholder.vue?vue&type=script&lang=js&"
export * from "./shareholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f4b573",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f4b573')) {
      api.createRecord('16f4b573', component.options)
    } else {
      api.reload('16f4b573', component.options)
    }
    module.hot.accept("./shareholder.vue?vue&type=template&id=16f4b573&scoped=true&", function () {
      api.rerender('16f4b573', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/shareholder.vue"
export default component.exports